// ============================================================
// ANSICHTSSACHE-AGENT – Kostenarten: der Name
// ============================================================
// Eine Kostenart IST ihr Name. Sie steht als Zeichenkette an der
// Ausgabe, an der Fixkostenposition und am Jahresbudget — eine
// Tabelle dafuer gibt es nicht, und ein Pflegeregister fuer eine
// einzige Zeichenkette waere ein Register zu viel.
//
// Aus dem MOCO-Bestand liegen allerdings noch englische
// Schluessel in den Daten (`software`, `travel`). Die uebersetzt
// die Tabelle hier — und nur die. Was ab jetzt erfasst wird,
// traegt den Namen, den jemand getippt oder gewaehlt hat, und
// braucht keinen Eintrag.
// ============================================================

/**
 * Die alten Schluessel aus dem Bestand. Hier kommt nichts mehr
 * dazu: eine neue Kostenart entsteht im Feld, nicht im Code.
 */
const LEGACY_LABELS: Record<string, string> = {
  travel: "Reise",
  software: "Software",
  office: "Büro",
  marketing: "Marketing",
  hosting: "Hosting",
  equipment: "Ausstattung",
  education: "Weiterbildung",
  meals: "Bewirtung",
};

/** Der deutsche Name zum alten Schluessel — sonst die Kostenart selbst. */
export function categoryLabel(key: string): string {
  return LEGACY_LABELS[key] ?? key;
}

/** Nach dem sichtbaren Namen, nicht nach dem Schluessel dahinter. */
export function compareCategories(a: string, b: string): number {
  return categoryLabel(a).localeCompare(categoryLabel(b), "de");
}

/**
 * Derselbe Name? Gross- und Kleinschreibung zaehlen nicht, Akzente
 * auch nicht: „hosting“ und „Hosting“ sind eine Kostenart, keine
 * zwei.
 */
export function sameCategoryName(a: string, b: string): boolean {
  return a.trim().localeCompare(b.trim(), "de", { sensitivity: "base" }) === 0;
}
